import { defineMessages } from 'react-intl';

const translations = {
  status: {
    inProgress: {
      id: 'pickListStatus.inProgress',
      defaultMessage: 'In progress',
      description: 'label of the pickment list status in progress',
    },
    onHold: {
      id: 'pickListStatus.onHold',
      defaultMessage: 'On hold',
      description: 'label of the pickment list status on hold',
    },
    cancelled: {
      id: 'pickListStatus.cancelled',
      defaultMessage: 'Cancelled',
      description: 'label of the pickment list status cancelled',
    },
    finished: {
      id: 'pickListStatus.finished',
      defaultMessage: 'Finished',
      description: 'label of the pickment list status finished',
    },
  },
};

export default defineMessages(translations);
